/* Elegance Coque — fenêtre Aperçu rapide (œil des cartes : ec-quick-eye.js). Modèle mémorisé (ECModel), couleur reprise de la carte. */
(function(){
if (window.ECQuick){ return; }
var d = document, W = window;
var ROOT = (W.Shopify&&W.Shopify.routes&&W.Shopify.routes.root)||'/';
var MODEL = 'Modèle iPhone';
var CARDS = '.lcard,.lcg-card,.ec-p,.lac-card,.lau__card[data-lau-card],.lmk-p,.lwl-card,.ecb-card';
var CFG = {};
try { CFG = JSON.parse((d.getElementById('ec-parcours-config')||{}).textContent||'{}'); } catch (e){}
var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';
var PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
var NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
var COLORS = { violet: '#7b5aa6', rose: '#f2b5c4', bleu: '#2f5da8', noir: '#111111', vert: '#2e6b4a', blanc: '#ffffff', marron: '#6b4a35', gris: '#9a9a9a', 'gris anthracite': '#3d3f42', 'bleu marine': '#14213d', 'marron rosé': '#b98b82', 'beige gris': '#c9bfae', 'blanc gris': '#e8e6e1', orange: '#e8742a', taupe: '#8b7b6e', 'noir fumé': '#2b2b2d', transparent: '#f1f1f1', prune: '#5b2a43', 'beige check': '#d8c3a5', 'marron ff': '#6b4a35', 'gris oblique': '#8d8d8d' };
var CACHE = {};

function esc(t){ var s = d.createElement('span'); s.textContent = t == null ? '' : String(t); return s.innerHTML; }
function money(c){
var v = (Number(c)||0) / 100, f = String(CFG.money||'{{amount}} DH');
var a = v.toFixed(2);
return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
if (k==='amount_no_decimals'){ return String(Math.round(v)); }
if (k==='amount_with_comma_separator'){ return a.replace('.', ','); }
return a;
});
}
function handleOf(u){ var m = String(u||'').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
function optNames(p){ return (p.options||[]).map(function(o){ return typeof o==='string' ? o : (o&&o.name)||''; }); }
function isColor(n){ return /^(couleur|color|colour)$/i.test(n); }
function valHandle(v){ return 'iphone-' + String(v||'').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
function storedModel(){
if (W.ECModel){ var m = W.ECModel.read(); return m ? m.handle : ''; }
try { return (W.localStorage.getItem('ec-model')||'').split('|')[0]; } catch (e){ return ''; }
}
function saveModel(val){
var m = { handle: valHandle(val), label: 'iPhone ' + val };
if (W.ECModel){ W.ECModel.save(m); return; }
try { W.localStorage.setItem('ec-model', m.handle + '|' + m.label); } catch (e){}
}
function img(u, w){ if (!u){ return ''; } u = u.indexOf('//')===0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w||800); }
function getProduct(h){
if (!CACHE[h]){
CACHE[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
.then(function(r){ if (!r.ok){ throw new Error('p'); } return r.json(); })
.catch(function(e){ delete CACHE[h]; throw e; });
}
return CACHE[h];
}

var dlg = null, cur = null, lastBtn = null, scrollY0 = 0;
function build(){
dlg = d.createElement('dialog');
dlg.className = 'ecqv'; dlg.setAttribute('aria-labelledby', 'ecqv-t');
dlg.innerHTML =
'<div class="ecqv__in">' +
'<button type="button" class="ecqv__x" data-ecqv-close aria-label="Fermer l’aperçu">' + X + '</button>' +
'<div class="ecqv__gal">' +
'<div class="ecqv__track" data-ecqv-track tabindex="0" aria-label="Photos du produit"></div>' +
'<button type="button" class="ecqv__nav ecqv__nav--p" data-ecqv-nav="-1" aria-label="Photo précédente">' + PREV + '</button>' +
'<button type="button" class="ecqv__nav ecqv__nav--n" data-ecqv-nav="1" aria-label="Photo suivante">' + NEXT + '</button>' +
'<div class="ecqv__dots" data-ecqv-dots></div>' +
'</div>' +
'<div class="ecqv__info">' +
'<h2 class="ecqv__t" id="ecqv-t" data-ecqv-title></h2>' +
'<p class="ecqv__pr" data-ecqv-price></p>' +
'<div data-ecqv-opts></div>' +
'<p class="ecqv__help" data-ecqv-help hidden><button type="button" class="ecp-helplink" data-ecp-help>Je ne connais pas mon modèle</button></p>' +
'<div class="ecqv__qty"><span class="ecqv__lbl" id="ecqv-ql">Quantité</span>' +
'<div class="ecqv__step" role="group" aria-labelledby="ecqv-ql">' +
'<button type="button" data-ecqv-q="-1" aria-label="Diminuer la quantité">−</button>' +
'<input type="number" min="1" max="99" value="1" inputmode="numeric" data-ecqv-qty aria-label="Quantité">' +
'<button type="button" data-ecqv-q="1" aria-label="Augmenter la quantité">+</button>' +
'</div></div>' +
'<p class="ecqv__msg" data-ecqv-msg role="alert"></p>' +
'<div class="ecqv__acts">' +
'<button type="button" class="ecqv__b ecqv__b--add" data-ecqv-add>AJOUTER AU PANIER</button>' +
'<button type="button" class="ecqv__b ecqv__b--buy" data-ecqv-buy>ACHETER MAINTENANT</button>' +
'</div>' +
'<ul class="ecqv__infos" data-ecqv-infos></ul>' +
'<a class="ecqv__more" data-ecqv-more href="#">Voir la fiche produit</a>' +
'</div>' +
'</div>';
d.body.appendChild(dlg);
dlg.addEventListener('click', onClick);
dlg.addEventListener('cancel', function(e){ e.preventDefault(); close(); });
dlg.addEventListener('change', function(e){ if (e.target.matches('[data-ecqv-qty]')){ clampQty(); } });
var tr = dlg.querySelector('[data-ecqv-track]');
tr.addEventListener('scroll', function(){ W.clearTimeout(tr._t); tr._t = W.setTimeout(dots, 60); }, { passive: true });
tr.addEventListener('keydown', function(e){ if (e.key==='ArrowRight'){ go(1); } else if (e.key==='ArrowLeft'){ go(-1); } });
var infos = [];
infos.push('<li><b>Livraison</b> ' + esc(CFG.rule||'Livraison offerte avec toute commande contenant une coque. Accessoires seuls : 35 DH.') + (CFG.delay ? ' · ' + esc(CFG.delay) : '') + (CFG.zone ? ', ' + esc(String(CFG.zone).toLowerCase()) : '') + '</li>');
infos.push('<li><b>Paiement</b> ' + esc(CFG.payment||'à la livraison') + '</li>');
dlg.querySelector('[data-ecqv-infos]').innerHTML = infos.join('');
}
function clampQty(){
var q = dlg.querySelector('[data-ecqv-qty]'), n = Math.round(Number(q.value)||1);
n = Math.max(1, Math.min(99, n)); q.value = n; return n;
}
function vals(i){ var out = []; cur.p.variants.forEach(function(v){ var x = v.options[i]; if (out.indexOf(x) < 0){ out.push(x); } }); return out; }
function possible(i, val){
return cur.p.variants.some(function(v){
if (!v.available||v.options[i]!==val){ return false; }
for (var k = 0; k < cur.names.length; k++){ if (k!==i&&cur.sel[k] != null&&v.options[k]!==cur.sel[k]){ return false; } }
return true;
});
}
function variant(){ return cur.p.variants.filter(function(v){ return cur.sel.every(function(x, i){ return x != null&&v.options[i]===x; }); })[0]||null; }
function anyVariant(){ return variant()||cur.p.variants.filter(function(v){ return cur.sel.every(function(x, i){ return x == null||v.options[i]===x; }); })[0]||cur.p.variants[0]; }
function gallery(){
var tr = dlg.querySelector('[data-ecqv-track]'), ims = cur.p.images||[];
if (!ims.length&&cur.p.featured_image){ ims = [cur.p.featured_image]; }
cur.imgs = ims.map(function(u){ return String(u).split('?')[0]; });
tr.innerHTML = ims.map(function(u, i){
return '<figure class="ecqv__sl"><img src="' + esc(img(u, 800)) + '" srcset="' + esc(img(u, 480)) + ' 480w, ' + esc(img(u, 800)) + ' 800w, ' + esc(img(u, 1100)) + ' 1100w" sizes="(min-width: 750px) 420px, 92vw" alt="' + esc(cur.p.title + (ims.length > 1 ? ' – photo ' + (i + 1) : '')) + '"' + (i ? ' loading="lazy"' : '') + ' width="800" height="1000"></figure>';
}).join('');
var multi = ims.length > 1;
[].forEach.call(dlg.querySelectorAll('[data-ecqv-nav]'), function(b){ b.hidden = !multi; });
dlg.querySelector('[data-ecqv-dots]').innerHTML = multi ? ims.map(function(_, i){ return '<button type="button" data-ecqv-dot="' + i + '" aria-label="Photo ' + (i + 1) + '"></button>'; }).join('') : '';
tr.scrollLeft = 0; dots();
}
function idx(){ var tr = dlg.querySelector('[data-ecqv-track]'); return tr.clientWidth ? Math.round(tr.scrollLeft / tr.clientWidth) : 0; }
function show(i, smooth){
var tr = dlg.querySelector('[data-ecqv-track]'), n = tr.children.length; if (!n){ return; }
i = (i + n) % n;
try { tr.scrollTo({ left: i * tr.clientWidth, behavior: smooth===false ? 'auto' : 'smooth' }); } catch (e){ tr.scrollLeft = i * tr.clientWidth; }
}
function go(dir){ show(idx() + dir); }
function dots(){ var i = idx(); [].forEach.call(dlg.querySelectorAll('[data-ecqv-dot]'), function(b, k){ b.setAttribute('aria-current', k===i ? 'true' : 'false'); }); }
function toVariantImage(v, smooth){
var u = v&&v.featured_image&&(v.featured_image.src||v.featured_image);
if (!u){ return; }
/* 30-10 : comparaison par nom de fichier (les adresses diffèrent : « //cdn… » et « https://cdn… ») */
var fn = function(x){ return String(x).split('?')[0].split('/').pop(); };
var k = cur.imgs.map(fn).indexOf(fn(u));
if (k > -1){ show(k, smooth); }
}
function render(){
var html = '';
var order = cur.names.map(function(n, i){ return i; }).sort(function(a, b){ return (isColor(cur.names[a]) ? 0 : 1) - (isColor(cur.names[b]) ? 0 : 1); });
order.forEach(function(i){
var n = cur.names[i]; if (n==='Title'){ return; }
var model = i===cur.mi, color = isColor(n);
html += '<fieldset class="ecqv__grp' + (model ? ' ecqv__grp--model' : '') + '" data-ecqv-grp="' + i + '"><legend class="ecqv__lbl">' + (model ? 'Modèle d’iPhone' : esc(n)) +
(cur.sel[i] ? ' : <b>' + esc(model ? 'iPhone ' + cur.sel[i] : cur.sel[i]) + '</b>' : ' : <span class="ecqv__todo">à choisir</span>') + '</legend><div class="ecqv__vals">';
vals(i).forEach(function(val){
var on = cur.sel[i]===val, ok = possible(i, val), hex = COLORS[String(val).toLowerCase()];
html += '<button type="button" class="ecqv__v' + (color ? ' ecqv__v--c' : '') + '" data-ecqv-opt data-i="' + i + '" data-v="' + esc(val) + '" aria-pressed="' + on + '"' + (!ok ? ' aria-disabled="true"' : '') + '>' +
(color ? '<span class="ecqv__dot" style="background:' + (hex||'#cfc8bb') + '"></span>' : '') +
'<span>' + esc(model ? 'iPhone ' + val : val) + '</span>' + (!ok ? '<span class="ecqv__off">épuisé</span>' : '') + '</button>';
});
html += '</div></fieldset>';
});
dlg.querySelector('[data-ecqv-opts]').innerHTML = html;
dlg.querySelector('[data-ecqv-help]').hidden = cur.mi < 0;
var v = anyVariant();
var pr = dlg.querySelector('[data-ecqv-price]');
pr.innerHTML = v ? esc(money(v.price)) + (v.compare_at_price > v.price ? ' <s>' + esc(money(v.compare_at_price)) + '</s>' : '') : '';
var full = variant(), miss = cur.names.filter(function(n, i){ return n!=='Title'&&cur.sel[i] == null; });
var sold = !!(full&&!full.available)||!cur.p.available;
[].forEach.call(dlg.querySelectorAll('[data-ecqv-add],[data-ecqv-buy]'), function(b){ b.disabled = sold; });
dlg.querySelector('[data-ecqv-add]').textContent = sold ? 'ÉPUISÉ' : 'AJOUTER AU PANIER';
if (!miss.length){ msg(''); }
}
function msg(t){ dlg.querySelector('[data-ecqv-msg]').textContent = t||''; }
function missing(){
var i = cur.names.map(function(n, k){ return (n!=='Title'&&cur.sel[k] == null) ? k : -1; }).filter(function(k){ return k > -1; })[0];
if (i == null){ return false; }
var g = dlg.querySelector('[data-ecqv-grp="' + i + '"]');
msg(i===cur.mi ? 'Choisissez votre modèle d’iPhone.' : 'Choisissez : ' + cur.names[i].toLowerCase() + '.');
if (g){ g.classList.remove('is-alert'); void g.offsetWidth; g.classList.add('is-alert'); try { g.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e){} }
return true;
}
function onClick(e){
var t = e.target; if (!t.closest){ return; }
if (t===dlg||t.closest('[data-ecqv-close]')){ close(); return; }
var o = t.closest('[data-ecqv-opt]');
if (o){
var i = Number(o.getAttribute('data-i')), val = o.getAttribute('data-v');
if (o.getAttribute('aria-disabled')==='true'&&cur.sel[i]!==val){
cur.sel = cur.sel.map(function(x, k){ return k===i||k===cur.mi ? x : null; });
}
cur.sel[i] = val;
if (i===cur.mi){ saveModel(val); }
render();
if (isColor(cur.names[i])){ toVariantImage(anyVariant()); }
return;
}
var nav = t.closest('[data-ecqv-nav]'); if (nav){ go(Number(nav.getAttribute('data-ecqv-nav'))); return; }
var dt = t.closest('[data-ecqv-dot]'); if (dt){ show(Number(dt.getAttribute('data-ecqv-dot'))); return; }
var q = t.closest('[data-ecqv-q]');
if (q){ var inp = dlg.querySelector('[data-ecqv-qty]'); inp.value = (Number(inp.value)||1) + Number(q.getAttribute('data-ecqv-q')); clampQty(); return; }
if (t.closest('[data-ecqv-add]')){ add(); return; }
if (t.closest('[data-ecqv-buy]')){ buy(); return; }
}
function add(){
if (missing()){ return; }
var v = variant(); if (!v||!v.available){ render(); return; }
var b = dlg.querySelector('[data-ecqv-add]'); b.disabled = true; b.setAttribute('aria-busy', 'true');
fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: clampQty() }] }) })
.then(function(r){ return r.json().then(function(j){ if (!r.ok||j.status){ throw new Error(j.description||j.message||''); } return j; }); })
.then(function(){
try { d.dispatchEvent(new CustomEvent('lt:cart-changed')); } catch (e){}
close();
if (W.ECBuy){ W.ECBuy.open(true); }
})
.catch(function(err){ msg((err&&err.message)||'L’ajout n’a pas abouti. Veuillez réessayer.'); })
.then(function(){ b.disabled = false; b.removeAttribute('aria-busy'); });
}
function buy(){
if (missing()){ return; }
var v = variant(); if (!v||!v.available){ render(); return; }
var q = clampQty(), url = cur.p.url||(ROOT + 'products/' + cur.p.handle);
close();
if (W.ECBuy&&W.ECBuy.buyNow){ W.ECBuy.buyNow(v, q, url); }else{ location.href = ROOT + 'cart/' + v.id + ':' + q; }
}
function cardColor(card){
var b = card&&card.querySelector('.lsw__b[aria-pressed="true"]');
return b ? (b.getAttribute('data-name')||'') : '';
}
function open(h, btn){
if (!dlg){ build(); }
lastBtn = btn||null;
var card = btn&&btn.closest(CARDS);
btn&&btn.setAttribute('aria-busy', 'true');
return getProduct(h).then(function(p){
btn&&btn.removeAttribute('aria-busy');
var names = optNames(p);
cur = { p: p, card: card, names: names, mi: names.indexOf(MODEL), sel: names.map(function(){ return null; }) };
names.forEach(function(n, i){
var vs = vals(i);
if (vs.length===1){ cur.sel[i] = vs[0]; return; }
if (i===cur.mi){
var hh = storedModel(), hit = hh ? vs.filter(function(x){ return valHandle(x)===hh; })[0] : null;
cur.sel[i] = hit||null;
return;
}
if (isColor(n)){
var c = cardColor(card);
if (c&&vs.indexOf(c) > -1){ cur.sel[i] = c; return; }
var fa = p.variants.filter(function(v){ return v.available; })[0]||p.variants[0];
cur.sel[i] = fa.options[i];
}
});
dlg.querySelector('[data-ecqv-title]').textContent = p.title;
dlg.querySelector('[data-ecqv-more]').setAttribute('href', (p.url||(ROOT + 'products/' + p.handle)) + (variant() ? '?variant=' + variant().id : ''));
dlg.querySelector('[data-ecqv-qty]').value = 1;
gallery(); render(); msg('');
scrollY0 = W.scrollY||0;
if (dlg.showModal){ dlg.showModal(); }else{ dlg.setAttribute('open', ''); }
d.documentElement.classList.add('ecqv-lock');
toVariantImage(anyVariant(), false);
var f = dlg.querySelector('.ecqv__x'); try { f.focus({ preventScroll: true }); } catch (e){}
}).catch(function(){
btn&&btn.removeAttribute('aria-busy');
location.href = ROOT + 'products/' + encodeURIComponent(h);
});
}
function close(){
if (!dlg||!dlg.hasAttribute('open')){ return; }
if (cur&&cur.card){
var ci = -1; cur.names.forEach(function(n, i){ if (isColor(n)){ ci = i; } });
var col = ci > -1 ? cur.sel[ci] : '';
if (col&&cardColor(cur.card)!==col){
var sw = [].filter.call(cur.card.querySelectorAll('.lsw__b'), function(b){ return b.getAttribute('data-name')===col; })[0];
if (sw){ sw.click(); }
}
}
if (dlg.close){ dlg.close(); }else{ dlg.removeAttribute('open'); }
d.documentElement.classList.remove('ecqv-lock');
if (Math.abs((W.scrollY||0) - scrollY0) > 2){ try { W.scrollTo(0, scrollY0); } catch (e){} }
if (lastBtn&&lastBtn.isConnected){ try { lastBtn.focus({ preventScroll: true }); } catch (e){} }
try { d.dispatchEvent(new CustomEvent('ec:model-changed')); } catch (e){}
}

W.ECQuick = { open: open, close: close, prefetch: function(h){ return getProduct(h); } };
})();